var _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSticky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(0px,0px); } 15% { transform: translate(0px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { transform: translate(0px,13.60006px); } 65% { transform: translate(0px,13.60006px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(-13.6001px,13.60006px); } }\n@keyframes a0_o { 0% { opacity: 1; } 15% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 65% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { opacity: 1; } }\n@keyframes a1_t { 0% { transform: translate(0px,0px); } 15% { transform: translate(0px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { transform: translate(13.6px,0px); } 65% { transform: translate(13.6px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(13.6px,13.60006px); } }\n@keyframes a1_o { 0% { opacity: 1; } 15% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 65% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { opacity: 1; } }\n@keyframes a2_t { 0% { transform: translate(0px,0px); } 15% { transform: translate(0px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { transform: translate(-13.6001px,0px); } 65% { transform: translate(-13.6001px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(-13.6001px,-13.6px); } }\n@keyframes a2_o { 0% { opacity: 1; } 15% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 65% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { opacity: 1; } }\n@keyframes a3_t { 0% { transform: translate(0px,0px); } 15% { transform: translate(0px,0px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { transform: translate(0px,-13.6px); } 65% { transform: translate(0px,-13.6px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(13.6px,-13.6px); } }\n@keyframes a3_o { 0% { opacity: 1; } 15% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 50% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 65% { opacity: 0.4; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { opacity: 1; } }\n    ")), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1001,3.49994L20.5001,3.49994L20.5001,6.89994L17.1001,6.89994L17.1001,3.49994Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(18.8001,5.19994) translate(-18.8001,-5.19994)",
    style: {
      animation: "2s linear infinite both a0_t, 2s linear infinite both a0_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5,3.49994L6.9,3.49994L6.9,6.89994L3.5,6.89994L3.5,3.49994Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(5.2,5.19994) translate(-5.2,-5.19994)",
    style: {
      animation: "2s linear infinite both a1_t, 2s linear infinite both a1_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1001,17.1L20.5001,17.1L20.5001,20.5L17.1001,20.5L17.1001,17.1Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(18.8001,18.8) translate(-18.8001,-18.8)",
    style: {
      animation: "2s linear infinite both a2_t, 2s linear infinite both a2_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5,17.1L6.9,17.1L6.9,20.5L3.5,20.5L3.5,17.1Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(5.2,18.8) translate(-5.2,-18.8)",
    style: {
      animation: "2s linear infinite both a3_t, 2s linear infinite both a3_o"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticky);
export default __webpack_public_path__ + "static/media/sticky.a4e7472116e4a379196374746649715d.svg";
export { ForwardRef as ReactComponent };